import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { ScheduledEventsCommonModule } from 'rev-portal/scheduledEvents/common/ScheduledEventsCommon.AngularModule';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DialogRegistrationService } from 'rev-shared/ui/dialog/DialogRegistration.Service';
import { VbUiTooltipModule } from 'rev-shared/ui/tooltip/VbUiTooltip.Module';

import { VbWebcastBannerSidebarComponent } from './VbWebcastBannerSidebar.Component';
import { VbWebcastBannerAtEndDialogComponent } from './VbWebcastBannerAtEndDialog.Component';

import styles from './VbWebcastBanner.module.less';

const components = [
	VbWebcastBannerSidebarComponent,
	VbWebcastBannerAtEndDialogComponent
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule,
		VbUiTooltipModule,
		ScheduledEventsCommonModule,
		ButtonsAngularModule
	]
})
export class VbWebcastBannerModule {
	constructor(dialog: DialogRegistrationService) {
		dialog.register('AtEndDialog', { component: VbWebcastBannerAtEndDialogComponent, class: styles.dialogContainer });
	}
}
